import React, { useState } from 'react';
import Footer from '~/components/Footer';
import Menu from '~/components/Menu';
import { Container } from '~/styles/pagesStyle';
import Card from './Card';
import '../../Page.css';

const initialForm = {
  info: [
    'ler',
    'incluir',
    'atualizar',
    'deletar',
    'upload',
    'download',
    'outros',
  ],
  ler: true,
  incluir: true,
  atualizar: true,
  deletar: true,
  upload: true,
  download: true,
  outros: true,
};

function PermissaoGrupo() {
  const [form, setForm] = useState(initialForm);
  return (
    <Container>
      <Footer />
      <Menu />
      <Card setForm={setForm} form={form} />
    </Container>
  );
}

export default PermissaoGrupo;
